import { render } from "./PracticeCreationForm.vue?vue&type=template&id=39eb7ea6&scoped=true"
import script from "./PracticeCreationForm.vue?vue&type=script&lang=js"
export * from "./PracticeCreationForm.vue?vue&type=script&lang=js"

import "./PracticeCreationForm.vue?vue&type=style&index=0&id=39eb7ea6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eb7ea6"]])

export default __exports__